import React from 'react';
import styled from 'styled-components';
import { Header } from '@app/navigation/header';
import { Body } from '@ui';
import { Page } from '@ui';
import { scrollToTop } from '@utils/usefulFuncs';
import { DocumentUploadStatus } from '@containers/application/DocumentUploadStatus';
import { DocUploader } from '@containers/DigitalAnalyst/DocUploader';
import { DocumentOrganizer } from '@containers/application/DocumentOrganizer';

const PageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

const WIDE_WIDTH = 1400;

function DocumentManagement() {
  const [pageWidth] = React.useState(WIDE_WIDTH + 'px');

  React.useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <PageWrapper>
      <Header />
      <Body withFooter>
        <DocUploader pageWidth={pageWidth} />
        <Page width={pageWidth}>
          <DocumentUploadStatus />
        </Page>
        <Page width={pageWidth}>
          <DocumentOrganizer />
        </Page>
      </Body>
    </PageWrapper>
  );
}

export default DocumentManagement;
